import { Paging } from '@/graphql/generated';

export const pagingDefaults = { offset: 0, limit: 10 };

export const hasNextPage = (paging: Paging) => paging.totalCount > paging.offset + paging.limit;
